<div class="main-container" *ngIf="dataNote && !compactMode && !compactView" data-cy="note-viewer-main-container">

  <div class="top-section" data-cy="note-viewer-top-section">
    <mat-form-field class="note-form-field" data-cy="note-viewer-form-field">
      <textarea matInput
                class="note-text-area"
                placeholder="Leave a note"
                [readonly]="!editable"
                (keyup)="startSaveTimer()"
                [(ngModel)]="dataNote.Note"
                [matTextareaAutosize]="false"
                [rows]="10"
                data-cy="note-viewer-textarea"></textarea>
    </mat-form-field>

    <div class="builder-buttons-container" data-cy="note-viewer-buttons-container">
      <button mat-button color="primary" matTooltip="Minimize note" (click)="compactMode = true;" class="builder-button" data-cy="note-viewer-minimize-button"><i class="material-icons">expand_less</i></button>
      <button mat-button color="primary" *ngIf="editable" class="builder-button" (click)="handleSaveNote()" matTooltip="Save note" data-cy="note-viewer-save-button">
        <i *ngIf="!isSaving" class="material-icons">save</i>
        <mat-spinner *ngIf="isSaving" [diameter]="20" data-cy="note-viewer-save-spinner"></mat-spinner>
      </button>
      <button mat-button color="primary" *ngIf="editable" class="builder-button" (click)="openNoteBuilderDialog()" matTooltip="Note Builder" data-cy="note-viewer-builder-button"><i class="material-icons">notes</i></button>
      <button mat-button color="primary" *ngIf="editable" class="builder-button" (click)="openNoteBoilerplateDialog()" matTooltip="Macro Notes" data-cy="note-viewer-macro-button"><i class="material-icons">account_tree</i></button>
      <button mat-button color="primary" *ngIf="editable" class="builder-button" (click)="deleteNote()" matTooltip="Delete Note" data-cy="note-viewer-delete-button"><i class="material-icons">delete</i></button>
    </div>

  </div>

  <div class="bottom-section" data-cy="note-viewer-bottom-section">
    <!-- Categories -->
    <div class="category-list category-margin" data-cy="note-viewer-category-container">
      <app-tdo-multiselect-dropdown placeholder="Category"
                                    [items]="dataNoteCategoryEnums.enumValidValueItems"
                                    [selectedItems]="selectedCategories"
                                    valueExp="ValidValueItemId"
                                    displayExp="ItemDisplayValue"
                                    (onChange)="onCatChange($event)"
                                    [editable]="editable"
                                    data-cy="note-viewer-category-dropdown">
      </app-tdo-multiselect-dropdown>
    </div>

    <!-- Types -->
    <div class="category-list category-margin" data-cy="note-viewer-type-container">
      <app-tdo-multiselect-dropdown placeholder="Types"
                                    [items]="dataNoteTypeEnums.enumValidValueItems"
                                    [selectedItems]="selectedTypes"
                                    valueExp="ValidValueItemId"
                                    displayExp="ItemDisplayValue"
                                    (onChange)="onTypeChanged($event)"
                                    [editable]="editable"
                                    data-cy="note-viewer-type-dropdown">
      </app-tdo-multiselect-dropdown>
    </div>

    <div class="created-details" data-cy="note-viewer-details">
      <div class="detail" data-cy="note-viewer-created-detail">
        Created on: {{ dataNote.xauditCreatedOn | date }}
        <div *ngIf="dataNote.xauditCreatedBy" data-cy="note-viewer-created-by">
          Created by: {{ dataNote.xauditCreatedByUser.UserName }}
        </div>
      </div>
      <div class="detail" data-cy="note-viewer-modified-detail">
        Last modified on: {{ dataNote.xauditModifiedOn | date }}
        <div *ngIf="dataNote.xauditModifiedBy" data-cy="note-viewer-modified-by">
          Last modified by: {{ dataNote.xauditModifiedByUser.UserName }}
        </div>
      </div>
    </div>
  </div>
</div>
<div class="main-container" *ngIf="dataNote && compactMode && !compactView" data-cy="note-viewer-compact-container">
  <div class="note-form-field" data-cy="note-viewer-compact-text">
    {{ getPreview(dataNote.Note) }}
  </div>
  <div class="builder-buttons-container" data-cy="note-viewer-compact-buttons">
    <button mat-button color="primary" matTooltip="Maximize note" (click)="compactMode = false;" data-cy="note-viewer-maximize-button"><i class="material-icons">expand_more</i></button>
  </div>
</div>

<div class="w-100" *ngIf="dataNote && compactView" data-cy="note-viewer-compact-view">
  <div class="row w-100" data-cy="note-viewer-compact-row">
    <div class="col" data-cy="note-viewer-compact-col">
      <mat-form-field class="w-100" data-cy="note-viewer-compact-field">
        <textarea matInput
                  placeholder="Leave a note"
                  [readonly]="!editable"
                  (keyup)="startSaveTimer()"
                  [(ngModel)]="dataNote.Note"
                  [matTextareaAutosize]="false"
                  [rows]="2"
                  data-cy="note-viewer-compact-textarea"></textarea>
      </mat-form-field>
    </div>
  </div>

  <div class="row w-100" data-cy="note-viewer-compact-dropdown-row">
    <div class="col-6" data-cy="note-viewer-compact-category-col">
      <!-- Categories -->
      <app-tdo-multiselect-dropdown placeholder="Category"
                                    [items]="dataNoteCategoryEnums.enumValidValueItems"
                                    [selectedItems]="selectedCategories"
                                    valueExp="ValidValueItemId"
                                    displayExp="ItemDisplayValue"
                                    (onChange)="onCatChange($event)"
                                    [editable]="editable"
                                    data-cy="note-viewer-compact-category-dropdown">
      </app-tdo-multiselect-dropdown>
    </div>
    <div class="col-6" data-cy="note-viewer-compact-type-col">
      <!-- Types -->
      <app-tdo-multiselect-dropdown placeholder="Types"
                                    [items]="dataNoteTypeEnums.enumValidValueItems"
                                    [selectedItems]="selectedTypes"
                                    valueExp="ValidValueItemId"
                                    displayExp="ItemDisplayValue"
                                    (onChange)="onTypeChanged($event)"
                                    [editable]="editable"
                                    data-cy="note-viewer-compact-type-dropdown">
      </app-tdo-multiselect-dropdown>
    </div>
  </div>
</div>

<div class="error-container" *ngIf="!dataNote" data-cy="note-viewer-error">
  Error reading data note.
</div>
